(function () {
//This clears the hamburger menu if the Back button is clicked in the browser
window.onpageshow = function(event) {
  if (event.persisted) {
    window.location.reload();
  }
};
//This scrolls to top on page reload to keep navigation integrity
window.onpageshow = function () {
    window.scrollTo(0,0);
};
})();
//This changes common jQuery events to act passive, saving page speed resources
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};
jQuery(document).ready( function() {
  //Add and remove class on scroll for header transparency on the Home page
  if (jQuery('body.home').length > 0 || jQuery('body.page-template-template-main').length > 0 || jQuery('body.page-template-template-maintwo').length > 0 || jQuery('body.page-template-template-mainthree').length > 0 || jQuery('body.single-case-study').length > 0 || jQuery('body.page-template-template-form').length > 0 || jQuery('body.page-template-template-thanks').length > 0) {
    jQuery(window).on("scroll", function() {
      if(jQuery(window).scrollTop()) {
        jQuery('header').removeClass('pursuit_scroll_trans');
      } else {
        jQuery('header').addClass('pursuit_scroll_trans');
      }
    });
  }
  jQuery('#pursuit_main_nav a.nav-link').filter(function(){
    return this.href === location.href;
  }).addClass('pursuit_active_main_nav');
  //Make top level Bootstrap nav clickable, even with dropdown
  jQuery('#pursuit_main_nav a.dropdown-toggle').on( "click", function() {
    location.href = jQuery(this).attr('href');
  });
  //Keep the active class styles on when hovering inside a dropdown
  jQuery('.dropdown-menu').hover(function(){
    var thisMain = jQuery(this).prev().find('span');
    jQuery(this).prev().find('span').addClass("nav-link__active");
  }, function () {
    jQuery(this).prev().find('span').removeClass("nav-link__active");
  });
  //Hamburger menu opener
  jQuery(".hamburger").on("click touch", function() {
    jQuery(".hamburger").toggleClass("is-active");
    jQuery(".hamMenuBlock").removeClass("hamMenuStart");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockOpen");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockClose");
    jQuery("body").toggleClass("scrollStopper");
    if (jQuery(".hamMenuBlock").hasClass("hamMenuBlockClose")) {
      jQuery(".hamMenuBlock").delay(700).queue(function(next){
        jQuery(".hamMenuBlock").addClass("hamMenuStart");
        next();
      });
    }
  });
  //Hamburger menu sub menus
  jQuery('.hamMenuLinkSubArrow').on('click', function(){
    var thisAnswer = jQuery(this).parent().nextAll('.hamMenuLinkMainSubBlock').first();
    jQuery('.hamMenuLinkMainSubBlock').not(thisAnswer).slideUp('fast');
    jQuery(thisAnswer).slideToggle('fast');
    jQuery('.hamMenuLinkSubArrow').not(this).removeClass('hamMenuLinkSubArrowUp');
    jQuery(this).toggleClass('hamMenuLinkSubArrowUp');
  });
  // add title attribute to all iframe elements
  if (!jQuery('iframe').attr('title')) {
    jQuery('iframe').attr('title', 'Content from Gateless');
  }
  if (window.location.pathname == '/newsroom/') {
    FWP.hooks.addFilter('facetwp/flyout/facets', function(facets) {
      return ['categories', 'tags'];
    });
  }
});
